import { showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../action-creators";
import { setDynamicsCrmListObjectsType } from "../../actions/dynamicsActions";
import type { CRMListObjectsType } from "../../../types";
import { selectDynamicsListObjectsType } from "../../selectors/dynamicsSelectors";

export const putDynamicsAccountsToggleThunk =
    (status: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.putAccountsStatusAsync.request());
            const response = await deps.si.api.management.putDynamicsAccountsFilterStatus(status);
            dispatch(managementActions.dynamics.putAccountsStatusAsync.success(response));
        } catch (error) {
            dispatch(managementActions.dynamics.putAccountsStatusAsync.failure(error));
        }
    };

export const putDynamicsContactsToggleThunk =
    (value: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.putContactsToggleAsync.request());
            const response = await deps.si.api.management.putDynamicsContactsFilterStatus(value);
            dispatch(managementActions.dynamics.putContactsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.dynamics.putContactsToggleAsync.failure(error));
        }
    };

export const putDynamicsLeadsToggleThunk =
    (value: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.putLeadsToggleAsync.request());
            const response = await deps.si.api.management.putDynamicsLeadsToggle(value);
            dispatch(managementActions.dynamics.putLeadsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.dynamics.putLeadsToggleAsync.failure(error));
        }
    };

export const putDynamicsCompanyAsLeadsToggleThunk =
    (value: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.putLeadsToggleAsync.request());
            const response = await deps.si.api.management.putDynamicsCompanyAsLeadsToggle(value);
            dispatch(managementActions.dynamics.putLeadsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.dynamics.putLeadsToggleAsync.failure(error));
        }
    };

export const setIsDynamicsCrmLabelEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.setIsDynamicsCrmLabelEnabled(payload));
            await deps.si.api.management.setIsDynamicsCrmLabelEnabled(payload);
        } catch (error) {
            dispatch(managementActions.dynamics.setIsDynamicsCrmLabelEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-label-enabled.error")));
        }
    };

export const setIsDynamicsCrmListEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.setIsDynamicsCrmListEnabled(payload));
            await deps.si.api.management.setIsDynamicsCrmListEnabled(payload);
        } catch (error) {
            dispatch(managementActions.dynamics.setIsDynamicsCrmListEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-list-enabled.error")));
        }
    };

export const setDynamicsCrmListObjectsTypeThunk =
    (objectsType: CRMListObjectsType) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        const prevObjectsType = selectDynamicsListObjectsType(getState());
        try {
            dispatch(setDynamicsCrmListObjectsType(objectsType));
            await deps.si.api.management.setDynamicsCrmListObjectsType(objectsType);
        } catch (error) {
            dispatch(setDynamicsCrmListObjectsType(prevObjectsType));
            dispatch(showErrorToast(translate("si.crm-integration.update-crm-list-objects-type.error")));
        }
    };
